import './Feeling.css'
import Text from './Text'

const Feeling = ({selected}: {
  selected: (choice: number) => void
}) => {
  return (
    <div className="vr-feeling-container">
        <Text type="subtitle" className='text-center'>How are you feeling right now?</Text>
        <div className="vr-feeling-options">
          <button className="vr-feeling-option emoji-red" aria-label="Select mood level 1 - very sad" onClick={() => selected(1)}><img src={'/assets/mood-emojies/mood-1.svg'} alt="1" />1</button>
          <button className="vr-feeling-option emoji-orange" aria-label="Select mood level 2 - sad" onClick={() => selected(2)}><img src={'/assets/mood-emojies/mood-2.svg'} alt="2" />2</button>
          <button className="vr-feeling-option emoji-yellow" aria-label="Select mood level 3 - neutral" onClick={() => selected(3)}><img src={'/assets/mood-emojies/mood-3.svg'} alt="3" />3</button>
          <button className="vr-feeling-option emoji-light-green" aria-label="Select mood level 4 - happy" onClick={() => selected(4)}><img src={'/assets/mood-emojies/mood-4.svg'} alt="4" />4</button>
          <button className="vr-feeling-option emoji-green" aria-label="Select mood level 5 - very happy" onClick={() => selected(5)}><img src={'/assets/mood-emojies/mood-5.svg'} alt="5" />5</button>
      </div>
    </div>
  )
}

export default Feeling;